import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "antd/dist/antd.less";
import "./style/main.scss";
import reportWebVitals from "./reportWebVitals";
import Router from "./routes";
import { FontProvider } from "@context/fontProvider";
__webpack_nonce__ = (window as any).nonce;

if (window.location.href?.includes('logout')) {
  console.log('sso logout html')
  localStorage.clear()
}

const App = () => {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
};

ReactDOM.render(
  <FontProvider>
    <App />
  </FontProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (process.env.ENV !== "production") {
  reportWebVitals(console.log);
}
